<textarea ngDefaultControl [name]='"tinymce_" + elementId' id="{{ elementId }}">{{ initialContent || '' }}</textarea>
